<p-dialog
  [header]="'mobile-status.organization.info-popup' | translate"
  [modal]="true"
  [(visible)]="showInfoPopup"
  [style]="{ width: '30%' }"
  (onHide)="clearPopupInfos()"
>
  <div class="show-info-container">
    <div class="show-info-box">
      <div class="show-info-box-details">
        <div class="show-info-box-detail">
          <label for=""
            >{{ "mobile-status.organization.created-at" | translate }}:</label
          >
          <span class="show-info-createdAt">{{
            data?.createdAt | dateFormat : true
          }}</span>
        </div>
        <div class="show-info-box-detail">
          <label for=""
            >{{ "mobile-status.organization.created-by" | translate }}:</label
          >
          <span class="show-info-createdBy"
            >{{ data?.createdBy?.firstName ?? "" }}
            {{ data?.createdBy?.lastName ?? "" }}</span
          >
        </div>
      </div>
    </div>
  </div>
</p-dialog>
